@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.destinations

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.locationpoint.LocationPointDto


object GetPassengerFavoritePointsRecommendationsEndpoint :
    EndPoint<GetPassengerFavoritePointsRecommendationsEndpoint.Request, GetPassengerFavoritePointsRecommendationsEndpoint.Response>() {
    class Request(
        val pageSize: Int,
    )

    class Response(
        val passengerFavoritesRecommendations: Array<LocationPointDto>,
    )
}